import * as React from 'react';

import { CardRenderLocationType } from 'containers/molecules/Card/enum-card-render-location';
import { BlockIngredientType, IngredientType } from 'types/Recipe.js';
import { UiStateTypes } from '../../../hoc/Cards/withUiState';

export type IngredientListPropsType = {
	cardRenderLocation: CardRenderLocationType;
	ingredients: IngredientType[];
	variantAmount: Number;
	selectedPortion: Number;
	handleCloseRecipe: () => void;
	isMigrosAuthenticated: boolean;
	productsIds: string;
	uiState: UiStateTypes;
};

const RECIPE_BUTTON_ADD_CLASS = 'm-recipe__button-add';

export class IngredientList extends React.Component<IngredientListPropsType> {
	public static displayName = 'IngredientList';

	public convertSpecialChars(text: string): number {
		const charsToReplace = [
			{
				searchTerm: ',',
				replaceTerm: '.',
			},
			{
				searchTerm: '¼',
				replaceTerm: '.25',
			},
			{
				searchTerm: '½',
				replaceTerm: '.5',
			},
			{
				searchTerm: '¾',
				replaceTerm: '.75',
			},
		];

		charsToReplace.forEach((char) => {
			text = text.replace(char.searchTerm, char.replaceTerm);
		});

		return parseFloat(text) || 1;
	}

	public render() {
		const { selectedPortion, variantAmount, ingredients = [], cardRenderLocation = 'unknown' } = this.props;

		return ingredients.map((ingredient: IngredientType, index: number) => {
			const key = `${index}-${cardRenderLocation}-${ingredient.block.ingredient
				.map((block: BlockIngredientType) => block.id)
				.join('')}-${variantAmount}`;

			return (
				<div
					style={{ display: selectedPortion === variantAmount ? 'block' : 'none' }}
					data-variant-amount={variantAmount}
					key={key}
				>
					{ingredient.block.title && <h4 className="m-recipe__sub-title">{ingredient.block.title}</h4>}
					<ul className="m-recipe__ingredients__list">
						{ingredient.block.ingredient.map(
							(blockingredient: BlockIngredientType, ingredientIndex: number) => {
								return (
									<li
										key={`${ingredientIndex}-${blockingredient.id}`}
										className={`m-recipe__ingredients__item`}
										data-product-name={blockingredient.text}
										data-quantity={blockingredient.amount.quantity}
										data-unit={blockingredient.amount.unit}
									>
										<span className="m-recipe__ingredients__quantity">
											{blockingredient.amount.text}
										</span>
										<span className="m-recipe__ingredients__text">{blockingredient.text}</span>
									</li>
								);
							}
						)}
					</ul>

					<div className="m-recipe__button-wrapper">
						<div className={`${RECIPE_BUTTON_ADD_CLASS} ${variantAmount}`} />
					</div>
				</div>
			);
		});
	}
}

export default IngredientList;
